
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import oo from "../../../images/img/oo.png"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 40px;
            margin: 20px 0;
            width: 100%;
            gap: 40px;
            overflow: auto;
            
            &::-webkit-scrollbar {
                width: 0;
                width: 8px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #9e9b9b;
                border-radius: 10px;
            }
            &::-webkit-scrollbar-track {
                background-color: transparent;
            }

            .img-kamyonoo{
                width: 80px;
                height: 40px;
            }

            p{
                font-size: var(--font-size-md);
                line-height: 1.4;
                font-weight: var(--font-weight-lg);
                color: ${({theme}) => theme.mainTextColor};
                text-align: center;
            }


            .btn-container{
                display: flex;
                gap: 40px;
            }
        }
    }
`

const LoadAracAdetModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()


    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])
    // dispatch(deleteRouteItem(item))

  return (
    <Container onClick={() => dispatch(showModal(null))}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <img src={oo} alt="kamyoon" className="img-kamyonoo" />
                <p>Araç Adetiniz 5 Veya Daha Fazla Olduğu İçin Müşteri Temsilcimiz Tarafından Aranacaksınız.</p>
            <div className="btn-container">
                <Btn bgColor="#E85446" width={"120px"} handleClick={() => dispatch(showModal(null))}>Harika</Btn>
            </div>
            </div>
        </div>
    </Container>
  )
}

export default LoadAracAdetModal